import { useState } from 'react';
import TwoFactorEnrollConfirm from './TwoFactorEnrollConfirm';
import TwoFactorEnrollSetup from './TwoFactorEnrollSetup';

export default function TwoFactorEnroll({
    requiresLegacyConfirm,
    onComplete,
    onSkip,
    prefillPassword,
}: {
    requiresLegacyConfirm: boolean;
    onComplete: () => void;
    onSkip?: () => void;
    prefillPassword?: string;
}) {
    const [phase, setPhase] = useState<'confirm' | 'setup'>(
        requiresLegacyConfirm ? 'confirm' : 'setup',
    );

    if (phase === 'confirm') {
        return <TwoFactorEnrollConfirm onConfirmed={() => setPhase('setup')} onSkip={onSkip} />;
    }

    return (
        <TwoFactorEnrollSetup
            onComplete={onComplete}
            prefillPassword={prefillPassword}
            isLegacyReenrollment={requiresLegacyConfirm}
        />
    );
}
